<template>
  <b-modal v-model="inputVal"
           modal-class="history-modal"
           size="xl"
           centered
           hide-footer
  >
    <template #modal-title>{{$route.name === 'EditMerchant' ? '帳戶' :  ''}}狀態記錄</template>
    <template #default>
      <slot name="header"></slot>
      <DataTable
        :fields="fieldsOption"
        :mobileFields="mobileFields"
        :items="list"
        :total-result="total"
        :options.sync="options"
        :loading="loading"
        small
        showRowDetails
      >
        <template v-slot:cell(status)="{ value }">
          <StatusLabel :item="value"></StatusLabel>
        </template>
        <template v-slot:remarks="{ value }">
          <div style="white-space: normal; overflow: visible;">
            {{ value }}
          </div>
        </template>
      </DataTable>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { merge } from 'rxjs';
import {
  debounceTime,
  filter,
  pluck,
  switchMap,
  tap,
} from 'rxjs/operators';
import { BModal } from 'bootstrap-vue';
import StatusLabel from '@/components/StatusLabel.vue';
import vModelMixin from '@/mixins/v-model';
import dataTableMixin from '@/mixins/data-table';
import getCouponStatus, { getStatusRemarks, getPaymentCouponStatus, getPaymentCouponRemarks } from '@/helpers/coupon-status';
import DataTable from '@/components/DataTable.vue';
import removeHTMLTags from '@/filters/remove-html-tags';

export default {
  mixins: [vModelMixin, dataTableMixin],
  components: {
    BModal,
    DataTable,
    StatusLabel,
  },
  props: { id: [Number, String], viewName: String, statusType: String },
  data: () => ({
    fields: [
      {
        key: 'status',
        label: '狀態',
        formatter: (value, key, item) => getCouponStatus(item.status),
      },
      { key: 'createdAt', label: '更新時間' },
      {
        key: 'remarks',
        label: '詳情',
        formatter: (value, key, item) => removeHTMLTags(getStatusRemarks(item)),
      },
    ],

    paymentCouponFields: [
      {
        key: 'status',
        label: '狀態',
        formatter: (value, key, item) => getPaymentCouponStatus(item.status),
      },
      { key: 'createdAt', label: '更新時間' },
      {
        key: 'remarks',
        label: '詳情',
        formatter: (value, key, item) => removeHTMLTags(getPaymentCouponRemarks(item)),
      },
    ],

    mobileFields: [
      {
        key: 'status',
        label: '狀態',
        formatter: (value, key, item) => getPaymentCouponStatus(item.status),
      },
      { key: 'createdAt', label: '更新時間' },
    ],
  }),
  computed: {
    ...mapGetters(['role']),
    fieldsOption() {
      if (this.statusType) {
        return this.paymentCouponFields;
      }
      return this.fields;
    },
  },
  subscriptions() {
    const getData$ = () => this.httpRequest$({
      method: 'GET',
      url: `/agc-${this.role}-api/${this.$route.meta.controller}/statusHistory/${this.id}`,
    });

    const onModalShow$ = this.$watchAsObservable('value')
      .pipe(
        pluck('newValue'),
        filter((val) => val),
      );

    return {
      list: merge(
        this.onOptionsUpdate$,
        onModalShow$,
      )
        .pipe(
          tap(() => {
            this.loading = true;
          }),
          debounceTime(100),
          switchMap(getData$),
        ),
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/data-table/status-table-content';
@import '@/assets/scss/modal/status-modal';

.remarks {
  white-space: wrap;
  overflow: auto;
}
</style>
